import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { PARTNERSHIPS } from '~/scopes/partnerships/routes-names'

// Only US and FR have a mobile plans destination today
// Other markets will be available in the future.
export function useMobilePlansUrl() {
  const locale = useI18nLocale()
  const { market } = useMarketplace()
  const withLocale = useRouteLocationWithLocale()

  const mobilePlansUrl = computed(() => {
    if (market.countryCode === MarketCountryCode.US) {
      return withLocale({ name: PARTNERSHIPS.US_TELCO_COMPARISON })
    }

    if (market.countryCode === MarketCountryCode.FR) {
      return `/${locale}/service/bouygues-telecom`
    }

    return undefined
  })

  return { mobilePlansUrl }
}
